import * as React from "react";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";

import { AppShape, EmploymentShape, HurdleShape, DocTypes } from "@eave/shared/types/api";
import DocEntry from "../../shared/DocEntry";
import { loadApp } from "../../actions";
import APIClient from "../../../APIClient";
import { DocumentUploader } from "../../../DocumentUploader";
import { ContactMethodDocusign } from "./WVoERequestForm";

const mapUnderwriterStateToProps = (state, ownProps) => ({
  documents: ownProps.documents,
  documentType: ownProps.documentType,
  prompt: ownProps.prompt,
  onUpload: ownProps.onUpload,
  ownerEntityType: ownProps.ownerEntityType,
  ownerEntityID: ownProps.ownerEntityID,
  applicationID: ownProps.applicationID,
});

const mapUnderwriterDispatchToProps = dispatch => ({
  updateApplication: (dispatchType, payload) => {
    loadApp(dispatch, payload.id);
  },
});

const UnderwriterDocumentUploader = connect(
  mapUnderwriterStateToProps,
  mapUnderwriterDispatchToProps,
)(DocumentUploader as any);

interface WVoEReviewFormProps {
  app: AppShape;
  employment: EmploymentShape;
  hurdle: HurdleShape;
  dispatch?: Function;
}

class WVoEReviewForm extends React.Component<WVoEReviewFormProps, any> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onEditorHide() {
    this.setState({ viewingDocEntry: false });
  }

  markSent() {
    const { dispatch, app, employment } = this.props;
    APIClient.put(`/${app.id}/wvoe/${employment.id}`, {}).then(() => {
      loadApp(dispatch, app.id);
    });
  }

  renderSentToEmployerSection() {
    const { employment } = this.props;
    const wvoeSigReq = employment.wvoe_signature_request;

    if (wvoeSigReq.contact_method === ContactMethodDocusign) {
      return null;
    }

    if (wvoeSigReq.employee_signed && !wvoeSigReq.sent_to_employer_at) {
      return (
        <div>
          <p>
            Please print out this form and {wvoeSigReq.contact_method} it to
            {wvoeSigReq.contact_name} at {wvoeSigReq.contact_email}.
          </p>
          <Button bsSize="small" onClick={this.markSent.bind(this)}>
            Click here once you've sent it.
          </Button>
        </div>
      );
    }
    if (wvoeSigReq.all_signed && wvoeSigReq.sent_to_employer_at) {
      return (
        <div>
          <p>
            Sent to employer ({wvoeSigReq.contact_name}) to complete form via{" "}
            {wvoeSigReq.contact_method}.
          </p>
        </div>
      );
    }
  }

  renderDocReviewSection() {
    const { employment, app } = this.props;
    return (
      <div>
        {employment.wvoe_signature_request.contact_method !== ContactMethodDocusign && (
          <UnderwriterDocumentUploader
            documents={app.documents}
            documentType={DocTypes.WrittenVerificationOfEmployment}
            prompt="Please upload completed Written Verification of Employment Form"
            borrowerEntity={employment.borrower_entity}
            ownerEntityType="employment"
            ownerEntityID={employment.id}
            applicationID={app.id}
            showOnlyCurrentUploadsOfType
          />
        )}
        {employment.written_verification_of_employment !== null && (
          <div>
            <Button bsSize="small" onClick={() => this.setState({ viewingDocEntry: true })}>
              <i className="fa fa-check-circle" />
              View Document
            </Button>
            {this.state.viewingDocEntry && (
              <DocEntry
                onHide={this.onEditorHide.bind(this)}
                app={this.props.app}
                hurdle={this.props.hurdle}
                docId={this.props.employment.written_verification_of_employment.id}
                docNotFoundMsg=""
                modalTitle="Editing Written Verification of Employment Form"
              />
            )}
          </div>
        )}
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.renderSentToEmployerSection()}
        {this.renderDocReviewSection()}
      </div>
    );
  }
}

export default WVoEReviewForm;
